/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CallbackRequestBuilderNavigationMetadata, type CallbackRequestBuilder } from './callback/index.js';
// @ts-ignore
import { TransactionSetupRequestBuilderRequestsMetadata, type TransactionSetupRequestBuilder } from './transactionSetup/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/worldpay
 */
export interface WorldpayRequestBuilder extends BaseRequestBuilder<WorldpayRequestBuilder> {
    /**
     * The callback property
     */
    get callback(): CallbackRequestBuilder;
    /**
     * The transactionSetup property
     */
    get transactionSetup(): TransactionSetupRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WorldpayRequestBuilderUriTemplate = "{+baseurl}/api/payments/worldpay";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WorldpayRequestBuilderNavigationMetadata: Record<Exclude<keyof WorldpayRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    callback: {
        navigationMetadata: CallbackRequestBuilderNavigationMetadata,
    },
    transactionSetup: {
        requestsMetadata: TransactionSetupRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
